import { render, staticRenderFns } from "./CargoExpenseResponsabilityDropdown.vue?vue&type=template&id=87d00a82"
import script from "./CargoExpenseResponsabilityDropdown.vue?vue&type=script&lang=js"
export * from "./CargoExpenseResponsabilityDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports